import { Id_drawing, Id_floor, Id_category } from "../api/Identifiers";
import { get_state } from "./State";
import { Workorder } from "../workorders/Workorder";
import { Keys } from "./Datastore";

/** This file contains all the actions that can be sent to the dispatcher 
 * AWH TODO: relocate all the actions in cms_view_datastore here.
*/
export class Actions {
    

    public static readonly ACTION_ADD_FETCHED_ATTACHMENTS_FLOOR: string = 'ACTION_ADD_FETCHED_ATTACHMENTS_FLOOR';
    public static readonly ACTION_ADD_FETCHED_FINDINGS_FLOOR: string = 'ACTION_ADD_FETCHED_FINDINGS_FLOOR';

    public static readonly ACTION_API_CREATE_ATTACHMENT: string = 'ACTION_API_CREATE_ATTACHMENT'
    public static readonly ACTION_API_DELETEATTACHMENT_START: string = 'ACTION_API_DELETEATTACHMENT_START';
    public static readonly ACTION_API_DELETEATTACHMENT_FAIL: string = 'ACTION_API_DELETEATTACHMENT_FAIL';
    public static readonly ACTION_API_DELETEATTACHMENT_SUCCESS: string = 'ACTION_API_DELETEATTACHMENT_SUCCESS';

    public static readonly ACTION_CLEAR_ASSETS_DATA: string = "ACTION_CLEAR_ASSETS_DATA";
    public static readonly ACTION_CLEAR_ATTACHMENTS_DATA: string = 'ACTION_CLEAR_ATTACHMENTS_DATA';
    public static readonly ACTION_CLEAR_FINDINGS_DATA: string = 'ACTION_CLEAR_FINDINGS_DATA';

    public static readonly ACTION_API_CREATEATTACHMENT_FAIL: string = 'ACTION_API_CREATEATTACHMENT_FAIL';

    public static readonly ACTION_API_CREATEATTACHMENT_START: string = 'ACTION_API_CREATEATTACHMENT_START';
    public static readonly ACTION_API_CREATEATTACHMENT_SUCCESS: string = 'ACTION_API_CREATEATTACHMENT_SUCCESS';

    public static readonly ACTION_REMOVE_PUSHPIN_COORD: string = "ACTION_REMOVE_PUSHPIN_COORD";
    public static readonly ACTION_SET_ADD_ATTACHMENT_STATE: string = 'ACTION_SET_ADD_ATTACHMENT_STATE';
    public static readonly ACTION_SET_FETCHING_CATEGORIES: string = "ACTION_SET_FETCHING_CATEGORIES";
    public static readonly ACTION_SET_MENU_ATTACHMENTS_SELECTED = "ACTION_SET_MENU_ATTACHMENTS_SELECTED";
    public static readonly ACTION_SET_MENU_PUSHPIN_SELECTED: string = "ACTION_SET_MENU_PUSHPIN_SELECTED";
    public static readonly ACTION_SET_PUSHPIN_COORD: string = "ACTION_SET_PUSHPIN_COORD";
    public static readonly SET_WORKORDERS_QUERY: string = "SET_WORKORDERS_QUERY";
    public static readonly SET_ADD_ASSET_STATE:string = "SET_ADD_ASSET_STATE";
    public static readonly SET_ASSETS_SELECTED: string = "SET_ASSETS_SELECTED";

    public static readonly ACTION_SET_ENABLED_PHOTO_ATTACHMENT_CREATE: string = "ACTION_SET_ENABLED_PHOTO_ATTACHMENT_CREATE";
    public static readonly ACTION_SET_ENABLED_ALLOW_3D_LINK_CREATE: string = "ACTION_SET_ENABLED_ALLOW_3D_LINK_CREATE";
    public static readonly ACTION_SET_FETCHING_CMSVIEW_USER_CONFIGURATION: string = "ACTION_SET_FETCHING_CMSVIEW_USER_CONFIGURATION";
    public static readonly ACTION_SET_FETCHING_FINDINGS: string = "ACTION_SET_FETCHING_FINDINGS";
    public static readonly ACTION_SET_FINDINGS_DATA: string = "ACTION_SET_FINDINGS_DATA";

    public static readonly ACTION_SET_PUSHPIN_GET_COORD_START: string = 'ACTION_SET_PUSHPIN_GET_COORD_START';//data associated with this is point
    public static readonly ACTION_SET_PUSHPIN_GET_COORD_STOP: string = 'ACTION_SET_PUSHPIN_GET_COORD_STOP';

    public static readonly ACTION_UI_CREATEATTACHMENT_GET_COORD_START: string = 'ACTION_UI_CREATEATTACHMENT_GET_COORD_START';
    public static readonly ACTION_UI_CREATEATTACHMENT_GET_COORD_STOP: string = 'ACTION_UI_CREATEATTACHMENT_GET_COORD_STOP';

    public static readonly ACTION_UI_CREATEATTACHMENT_GET_FILE_START: string = 'ACTION_UI_CREATEATTACHMENT_GET_FILE_START';
    public static readonly ACTION_UI_CREATEATTACHMENT_GET_FILE_STOP: string = 'ACTION_UI_CREATEATTACHMENT_GET_FILE_STOP';

    public static readonly ACTION_UI_CREATEATTACHMENT_GET_LINK_START: string = 'ACTION_UI_CREATEATTACHMENT_GET_LINK_START';
    public static readonly ACTION_UI_CREATEATTACHMENT_GET_LINK_STOP: string = 'ACTION_UI_CREATEATTACHMENT_GET_LINK_STOP';

    public static readonly ACTION_SET_CATEGORY_DATA: string = 'ACTION_SET_CATEGORY_DATA';
    public static readonly ACTION_SET_SITEMAP_URL: string = 'ACTION_SET_SITEMAP_URL';

    public static readonly ACTION_ADD_FETCHED_ASSETS_FLOOR: string = 'ACTION_ADD_FETCHED_ASSETS_FLOOR';

    // updateattachment
    public static readonly ACTION_API_UPDATEATTACHMENT_FAIL: string = 'ACTION_API_UPDATEATTACHMENT_FAIL';
    public static readonly ACTION_API_UPDATEATTACHMENT_START: string = 'ACTION_API_UPDATEATTACHMENT_START';
    public static readonly ACTION_API_UPDATEATTACHMENT_SUCCESS: string = 'ACTION_API_UPDATEATTACHMENT_SUCCESS';

    public static readonly ACTION_UI_UPDATEATTACHMENT_START: string = 'ACTION_UI_UPDATEATTACHMENT_START';
    public static readonly ACTION_UI_UPDATEATTACHMENT_STOP: string = 'ACTION_UI_UPDATEATTACHMENT_STOP';

    public static readonly ACTION_UPDATE_ASSETS: string = 'ACTION_UPDATE_ASSETS';
    public static readonly ACTION_UPDATE_WORKORDERS: string = 'ACTION_UPDATE_WORKORDERS';
    public static readonly ACTION_UPDATE_FINDINGS: string = 'ACTION_UPDATE_FINDINGS'


    public static readonly ACTION_SET_ASSET_DATA: string = 'ACTION_SET_ASSET_DATA';
    public static readonly ACTION_SET_ATTACHMENTS_DATA: string = 'ACTION_SET_ATTACHMENTS_DATA';    // {data:{... output from CMS API call ...}}
    public static readonly ACTION_SET_BUILD_ID: string = 'ACTION_SET_BUILD_ID';
    public static readonly ACTION_SET_BUILDINGS_DATA: string = 'ACTION_SET_BUILDINGS_DATA';      // {data:{... output from CMS API call ...}}
    public static readonly ACTION_SET_FETCHING_ASSETS: string = 'ACTION_SET_FETCHING_ASSETS';
    public static readonly ACTION_SET_FETCHING_ATTACHMENTS: string = 'ACTION_SET_FETCHING_ATTACHMENTS';
    public static readonly ACTION_SET_FETCHING_BUILDINGS: string = 'ACTION_SET_FETCHING_BUILDINGS';
    public static readonly ACTION_SET_FETCHING_DRAWINGS_INFO: string = 'ACTION_SET_FETCHING_DRAWINGS_INFO';
    public static readonly ACTION_SET_FETCHING_FLOORPLANS: string = 'ACTION_SET_FETCHING_FLOORPLANS';
    public static readonly ACTION_SET_FETCHING_SITEMAP_DATA: string = 'ACTION_SET_FETCHING_SITEMAP_DATA';
    public static readonly SET_CATEGORY_DATA: string = 'ACTION_SET_CATEGORY_DATA';       // {data:{... output from CMS API call ...}}
    
    public static readonly ACTION_SET_FETCHING_WORKORDERS: string = 'ACTION_SET_FETCHING_WORKORDERS';
    public static readonly ACTION_SET_PRINTING_FINDINGS: string = 'ACTION_SET_PRINTING_FINDINGS'
    public static readonly ACTION_SET_FLOOR: string = 'ACTION_SET_FLOOR';               // {data:{id_floor:12345}} or {data:{id_drawing:"12345-6-7-8-9"}}
    public static readonly ACTION_SET_FLOOR_ONLY: string = 'ACTION_SET_FLOOR_ONLY';               // {data:id_floor}
    public static readonly ACTION_SET_ID_BUILDING: string = 'ACTION_SET_ID_BUILDING';               // {data:{id_floor:12345}} or {data:{id_drawing:"12345-6-7-8-9"}}
    public static readonly ACTION_SET_FLOORPLAN_DATA: string = 'ACTION_SET_FLOORPLAN_DATA';


    public static readonly ACTION_CLEAR_WORKORDERS_DATA: string = 'ACTION_CLEAR_WORKORDERS_DATA';
    public static readonly SET_MENU_WORKORDERS_SELECTED: string = "SET_MENU_WORKORDERS_SELECTED"; // menu_workorders_selected
    public static readonly SET_WORKORDERS_DATA: string = 'SET_WORKORDERS_DATA';

    public static readonly ACTION_SET_SITEMAP_DATA: string = 'ACTION_SET_SITEMAP_DATA'; //{data:{id_floor:1234}, {id_building:1234}, {locationDescription:"blah"}, {id_drawing:"12345-6-7-8-9"}}
    public static readonly ACTION_SET_DRAWINGS_INFO_DATA: string = 'ACTION_SET_DRAWINGS_INFO_DATA';
    public static readonly SET_ADD_FINDINGS_STATE: string = "SET_ADD_FINDINGS_STATE";
    public static readonly SET_ADD_WORKORDER_STATE:string = "SET_ADD_WORKORDER_STATE"
    public static readonly SET_ID_DRAWING: string = "SET_ID_DRAWING";
    public static readonly SET_ID_FLOOR: string = "SET_ID_FLOOR";
    public static readonly SET_KEY_BOOLEAN: string = "SET_KEY_BOOLEAN";
    public static readonly SET_KEY_STRING: string = "SET_KEY_STRING";

    public static readonly SET_FINDINGS_SELECTED: string = "SET_FINDINGS_SELECTED";
    public static readonly ACTION_SET_TOKEN_IS_BAD: string = "ACTION_SET_TOKEN_IS_BAD";
}

export class Action {
    public readonly action: string;
    public readonly data: any;

    private constructor(action: string, data: any) {
        this.action = action;
        this.data = data;
    }
    public static set_id_drawing(id_drawing: Id_drawing): Action {
        return new Action(Actions.SET_ID_DRAWING, id_drawing.toString());
    }
    public static set_id_floor(id_floor: Id_floor): Action {
        return new Action(Actions.SET_ID_FLOOR, id_floor.toString());
    }
    public static set_key_boolean(state_key: string, value: boolean): Action {
        return new Action(Actions.SET_KEY_BOOLEAN, [state_key, value]);
    }
    public static set_key_string(state_key: string, value: string): Action {
        return new Action(Actions.SET_KEY_STRING, [state_key, value]);
    }
    private static set_findings_categories_selected(state_key: string, finding_categories: Id_category[]): Action {
        return new Action(Actions.SET_FINDINGS_SELECTED, finding_categories);
    }

    public static set_menu_assets_expanded(is_expanded: boolean): Action {
        return Action.set_key_boolean(Keys.MENU_ASSETS_EXPANDED, is_expanded);
    }

    public static set_workorder_category_selected(workorder_category: string, is_selected: boolean): Action {
        var selected_workorders: string[] = get_state().menu_workorders_selected;

        if (is_selected) {
            selected_workorders.push(workorder_category);
        }
        else {
            selected_workorders = selected_workorders.filter(item => item !== workorder_category)
        }
        return new Action(Actions.SET_MENU_WORKORDERS_SELECTED, selected_workorders);
    }

    public static set_workorder_query(workorder_query: any): Action {
        return new Action(Actions.SET_WORKORDERS_QUERY, workorder_query)
    }

    private static set_asset_categories_selected(selected_asset_categories:Id_category[]):Action{
        return new Action(Actions.SET_ASSETS_SELECTED, selected_asset_categories);
    }

    private static set_finding_categories_selected(selected_finding_categories:Id_category[]):Action{
        return new Action(Actions.SET_FINDINGS_SELECTED, selected_finding_categories);
    }

    public static toggle_asset_category(id_category: Id_category, is_selected:boolean): Action {
        let selected_asset_categories: Id_category[] =  get_state().menu_asset_categories_selected;
        // Remove the asset category from the list. This will prevent duplicates
        selected_asset_categories=selected_asset_categories.filter((cat: Id_category)=>{
            return cat !== id_category;
        });
        if(is_selected){
            selected_asset_categories.push(id_category);
        }
        return Action.set_asset_categories_selected( selected_asset_categories);
    }
    public static toggle_attachments_layer(is_selected:boolean): Action {
        return new Action(Actions.ACTION_SET_MENU_ATTACHMENTS_SELECTED, is_selected);
    }
    

    public static toggle_all_asset_categories(toggle_on: boolean): Action {
        let selected_asset_categories: Id_category[] = [];
        if (toggle_on) {
            // add all categories to the selected categories list
            selected_asset_categories = get_state().categories.id_categories;
        }
        return Action.set_asset_categories_selected( selected_asset_categories);
    }
    
    public static toggle_all_findings_categories(toggle_on: boolean) {
        let selected_findings: any[] = [];
        if (toggle_on) {
            // add all categories to the selected categories list
            selected_findings = get_state().categories.id_categories;
        }
        return Action.set_finding_categories_selected(selected_findings);
    }

    public static toggle_all_workorder_categories(toggle_on: boolean): Action {
        let selected_workorder_categories: any[] = [];
        if (toggle_on) {
            // add all categories to the selected categories list
            get_state().workorders.workorders.forEach((workorder: Workorder) => {
                selected_workorder_categories.push(workorder.type);
            });
        }
        return new Action(Actions.SET_MENU_WORKORDERS_SELECTED, selected_workorder_categories);
    }

    public static toggle_finding_category_selected(id_category: Id_category, is_selected:boolean): Action {
        let selected_finding_categories: Id_category[] =  get_state().menu_finding_categories_selected;
        // Remove the asset category from the list. This will prevent duplicates
        selected_finding_categories=selected_finding_categories.filter((cat: Id_category)=>{
            return !(cat && cat.equals(id_category));
        });
        if(is_selected){
            selected_finding_categories.push(id_category);
        }
        return Action.set_finding_categories_selected( selected_finding_categories);
    }
    public static set_workorders_data(raw_wo_data:any){
        return new Action(Actions.SET_WORKORDERS_DATA, raw_wo_data);
    }

    public static update_workorders(workorders:any[]){
        return new Action(Actions.ACTION_UPDATE_WORKORDERS, workorders);
    }
}


// WEBPACK FOOTER //
// ./src/ts/redux/Actions.ts